import { urls } from "../urls";
export const memberService = urls.developmentUrl + ':5004/v1/'
// export const memberService = "https://b74a-41-215-76-14.ngrok.io/v1/";
export const bookingService = urls.developmentUrl + ":5005/";

export const houseHoldurls = {
  postHouseHold: memberService + "starts/post",
  getSettingHousehold: memberService + "type/household/",
  getHouseHolds: memberService + "households",
  getHouseHold: memberService + "type/household/",
  deleteHouseHold: memberService + "starts/delete/",
  editHouseHold: memberService + "starts/edit/",
  getAllHouseHolds: memberService + "households",
  restoreHouseHold: memberService + "starts/restore/",
  getDeletedHouseHold: memberService + "starts/deleted"
};

export const memberUrls = {
  requestMpesa: memberService + "member/payment",
  postMember: memberService + "add/member",
  postPublicMember: memberService + "add/public-member",
  postExistingMember: memberService + "add/existing/member",
  getMembers: memberService + "members",
  getMember: memberService + "member/",
  deleteMember: memberService + "members/delete/",
  editMember: memberService + "update/member/",
  editCorporateMember: memberService + "update/corporate-member",
  getAllMembers: memberService + "members",
  getAllBookingMembers: memberService + "members/booking",
  remindMembershipPayment: memberService + "membership/email/reminder/",
  restoreMember: memberService + "members/restore/",
  getDeletedMember: memberService + "members/deleted",
  getMemberVisits: bookingService + "bookings/member/view/",
  updateBeneficiary: memberService + "edit/beneficiary/",
  deleteMemberBeneficiary: memberService + "remove/family/",
  addBeneficiary: memberService + "add/beneficiary",
  getAllCorporateMembers: memberService + "corporate/member",
  getCorporateMember: memberService + "corporate/member/",
  addCorporateMember: memberService + "add/corporate/member",
  fetchMembersRevenueData: memberService + "revenue/chart",
  pushMembershipRecords: memberService + "members/salesforce"
};

export const memberTypeUrls = {
  postMemberType: memberService + "add/member/setting",
  getMemberTypes: memberService + "membertypes",
  getMemberGenders: memberService + "genders",
  getMemberType: memberService + "starts/single/",
  deleteMemberType: memberService + "starts/delete/",
  editMemberType: memberService + "update/member/setting",
  getAllMemberTypes: memberService + "membertypes",
  restoreMemberType: memberService + "starts/restore/",
  getDeletedMemberType: memberService + "starts/deleted"
};

export const residenceTypeUrls = {
  postResidenceType: memberService + "starts/post",
  getResidenceTypes: memberService + "residence",
  getResidenceType: memberService + "settings/residence/",
  deleteResidenceType: memberService + "starts/delete/",
  editResidenceType: memberService + "residence",
  getAllResidenceTypes: memberService + "residence",
  restoreResidenceType: memberService + "starts/restore/",
  getDeletedResidenceType: memberService + "starts/deleted"
};

export const membershipSettingUrls = {
  postMembershipSetting: memberService + "add/member/setting",
  getMembershipSettings: memberService + "member/settings",
  getMembershipSetting: memberService + "member/setting/",
  deleteMembershipSetting: memberService + "delete/member/setting",
  editMembershipSetting: memberService + "starts/edit/",
  getAllMembershipSettings: memberService + "member/settings",
  restoreMembershipSetting: memberService + "starts/restore/",
  getDeletedMembershipSetting: memberService + "starts/deleted",
  getAllGreenMembershipSettings: memberService + "member/green/settings"
};
